export default __webpack_public_path__ + "static/media/ceramol-iage-result-forever-young.39779bc0.png";